import { Browser } from '@phosphor-icons/react';

import { createEmbedProvider } from '../factory';

/** Mirrors Platform CustomIframe.ENABLED — keep in sync when either side changes */
export const CUSTOM_IFRAME_URL_REGEX = /^https:\/\/[a-zA-Z0-9-_]+\.[a-zA-Z0-9-_.]+\/.*\?.*customIframe=true.*$/;

export const iframeProvider = createEmbedProvider({
  id: 'iframe',
  label: 'Iframe',
  icon: <Browser size={20} weight="fill" className="text-green-500" />,
  placeholder: 'Paste an iframe link...',
  regex: CUSTOM_IFRAME_URL_REGEX,
  buildEmbedUrl: (_, url) => url,
  buildTitle: () => 'Custom Iframe',
});
